<script>
import ConsignacaoParcelas from '@/components/shared/consignacao/ConsignacaoParcelas.vue'

export default {
  extends: ConsignacaoParcelas,
}
</script>
